// Shared phone-number helpers. Backend stores contact phone/mobile in E.164
// (e.g. +13055551212); use these to coerce user input to that format before
// submission and to render it back as (555) 123-4567 in displays.

// Convert to E.164: +15551234567. Falls back to the raw input when we
// can't safely infer a country code (international/short/etc.), matching
// the backend resources.services.phone_service.normalize_contact_phone
// fallback so the FE and API agree.
export const toE164 = (value) => {
  if (!value) return value;
  const trimmed = String(value).trim();
  if (!trimmed || trimmed.toLowerCase() === "none") return "";
  // Already E.164.
  if (/^\+\d{7,15}$/.test(trimmed)) return trimmed;
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return trimmed;
};

// Format a phone string for display: (555) 123-4567. Strips the country
// code if it's +1.
export const formatPhoneDisplay = (value) => {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "");
  const local =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (local.length <= 3) return local;
  if (local.length <= 6) return `(${local.slice(0, 3)}) ${local.slice(3)}`;
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
};
